import { TextField } from '@/components/ui/TextField';
import { TITLE_FIELD_KEY } from '@/lib/presence/fieldKeys';

import { commitTrimmedDraft } from './commitTrimmedDraft';
import { blockedInputProps } from './fieldPresence/blockedInputProps';
import { FieldClaimFrame } from './fieldPresence/FieldClaimFrame';
import { useClaimableDraft } from './fieldPresence/useClaimableDraft';
import { useClaimableField } from './fieldPresence/useClaimableField';

/** Inline-editable template title, committed on blur. */
export function EditableTitle({
  initial,
  onCommit,
}: {
  initial: string;
  onCommit: (t: string) => void;
}) {
  const field = useClaimableField(TITLE_FIELD_KEY);
  const { inputRef, blocked } = field;
  const {
    draft: title,
    setDraft: setTitle,
    onFocus,
    onBlur,
  } = useClaimableDraft(field, initial, commitTrimmedDraft(initial, onCommit));
  return (
    <FieldClaimFrame field={field}>
      <TextField
        ref={inputRef}
        value={title}
        onChangeText={setTitle}
        {...blockedInputProps(blocked)}
        placeholder="Name this template"
        inputClassName="font-heading text-xl"
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </FieldClaimFrame>
  );
}
